import { apiService } from '@shared/services/apiServices';
import qmsCategoryEndpoints from './qmsCategoryEndpoints';
import type {
  ListQmsCategoryParams,
  ListQmsCategoryResponse,
} from '../types/qmsCategoryTypes';

export const listQmsCategoryApiService = {
  listCategories: async (
    params?: ListQmsCategoryParams
  ): Promise<ListQmsCategoryResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      params.status
        .split(',')
        .forEach((s) => queryParams.append('status', s.trim()));
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const qs = queryParams.toString();
    const endpoint = `${qmsCategoryEndpoints.CATEGORIES}${qs ? `?${qs}` : ''}`;
    const response = await apiService.getAPI(endpoint, {
      skipGlobalErrorRedirect: true,
    });

    if (response.error && response.status === 403) {
      const err = new Error('Forbidden') as Error & { status: number };
      err.status = 403;
      throw err;
    }

    if (response.error) {
      return {
        success: false,
        data: [],
        totalCount: 0,
        page: params?.page ?? 1,
        limit: params?.limit ?? 10,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
        error: 'Wystąpił błąd podczas ładowania danych.',
      };
    }

    return {
      success: true,
      ...(response.data as Omit<ListQmsCategoryResponse, 'success' | 'error'>),
    };
  },
};
